<div class="hotel-info-wrapper mt-6 leading-relaxed" *ngIf="hotelInfoSummery">
    <div *ngIf="hotelInfoSummery?.AboutHotel">

        <div class="flex items-center justify-between w-full">
            <h2 class="hotel-title mt-4 text-xl text-black-500 font-bold"
                [innerHTML]="'درباره ' + hotelInfoSummery?.Name"></h2>
        </div>
        <div class="hotel-BriefDescription space-y-3 mt-4 text-justify leading-relaxed"
            [innerHTML]="hotelInfoSummery.AboutHotel?.BriefDescription">
        </div>
        <div class="lg:hidden my-4">
            <button mat-button color="primary" (click)="showModal()" class="icon-arrow-button flex md:!hidden">
                <span>مشاهده بیشتر</span>
                <i class="ico-Left text-2xl"></i>
            </button>
        </div>
    </div>


    <div class="hidden md:block">
        <div class="hotel-LocationDescription space-y-3 mt-6 text-justify leading-relaxed"
            [innerHTML]="hotelInfoSummery.AboutHotel?.Description">
        </div>
        <div class="hidden md:block w-full h-px bg-gray-100 rounded-sm mt-6"></div>
        <div class="mt-6">
            <div *ngIf="hotelInfoSummery?.HotelCafe">
                <h3 class="mt-4 text-xl text-black-500 font-bold">رستوران ها و کافی شاپ های {{hotelInfoSummery.Name}}
                </h3>
                <div class="mt-4" *ngIf="hotelInfoSummery?.HotelCafe?.Description">
                    <h2 class="text-base font-bold">ساعت کاری و ظرفیت</h2>
                    <div class="hotel-resturants space-y-3 mt-2 text-justify leading-relaxed"
                        [innerHTML]="hotelInfoSummery?.HotelCafe?.Description">
                    </div>
                </div>

                <div class="hidden md:block w-full h-px bg-gray-100 rounded-sm mt-4"></div>
            </div>
            <div class="p-2 mt-2">
                <h3 class="text-black-500 font-bold text-xl">چند دلیل برای انتخاب {{hotelInfoSummery.Name}}</h3>
                <div class="w-full flex flex-col justify-center items-start">
                    <div class="flex flex-col md:flex-row w-full mt-6">
                        <div class="w-12/12 md:w-1/12 flex justify-start items-start">
                            <i class="text-2xl text-black-300 ico-Discount"></i>
                        </div>
                        <div class="w-12/12 md:w-11/12 md:-mr-10">
                            <h3 class="w-full text-black-500 text-base font-bold">ارائه کمترین قیمت</h3>
                            <div class="w-full text-sm leading-relaxed text-black-300">دریافت بهترین نرخ و صرفه جوئی در
                                پرداخت وجه به جای پرداخت قیمت برد واحد اقامتی</div>
                        </div>
                    </div>
                    <div  *ngIf="accommodation() !== 'ecolodge'" class="flex flex-col md:flex-row w-full mt-6">
                        <div class="w-12/12 md:w-1/12 flex justify-start items-start">
                            <i class="text-2xl text-black-300 ico-DiscountCircle"></i>
                        </div>
                        <div class="w-12/12 md:w-11/12 md:-mr-10">
                            <h3 class="w-full text-black-500 text-base font-bold">صفر درصد کارمزد کنسلی</h3>
                            <div class="w-full text-sm leading-relaxed text-black-300">در صورت لغو رزرو خود,شبکه ایران
                                هتل هیچ گونه کارمزد کنسلی از شما دریافت نخواهد کرد.لازم به ذکر است این کارمزد ارتباطی با
                                جریمه هتل ندارد</div>
                        </div>
                    </div>
                    <div *ngIf="hotelInfoSummery?.ReasonToChoose?.RateComment"
                        class="flex flex-col md:flex-row w-full mt-6">
                        <div class="w-12/12 md:w-1/12 flex justify-start items-start">
                            <i class="text-2xl text-black-300 ico-Message-line"></i>
                        </div>
                        <div class="w-12/12 md:w-11/12 md:-mr-10">
                            <h3 class="w-full text-black-500 text-base font-bold">بررسی نظرات میهمانان</h3>
                            <div class="w-full text-sm leading-relaxed text-black-300"
                                [innerHTML]="hotelInfoSummery?.ReasonToChoose?.RateComment"></div>
                        </div>
                    </div>
                    <div *ngIf="hotelInfoSummery?.ReasonToChoose?.ReasonToChoose"
                        class="flex flex-col md:flex-row w-full mt-6">
                        <div class="w-12/12 md:w-1/12 flex justify-start items-start">
                            <i class="text-2xl text-black-300 ico-Questions"></i>
                        </div>
                        <div class="w-12/12 md:w-11/12 md:-mr-10">
                            <h3 class="w-full text-black-500 text-base font-bold">دلایل ارائه شده هتل</h3>
                            <div class="w-full text-sm text-black-300 leading-relaxed"
                                [innerHTML]="hotelInfoSummery?.ReasonToChoose?.ReasonToChoose"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="hidden md:block w-full h-px bg-gray-100 rounded-sm mt-6"></div>
    </div>
</div>